<template>
  <v-dialog v-model="dialog" width="900" persistent>
    <template v-slot:activator="{ on, attrs }">
      <v-text-field
        class="rounded-10"
        label="설명 페이지 선택"
        outlined
        dense
        :value="selectedPageDisplay"
        readonly
        v-bind="attrs"
        v-on="on"
        append-icon="mdi-magnify"
        clearable
        @click:clear="clearSelection"
        placeholder="클릭하여 설명 페이지를 선택하세요"
      ></v-text-field>
    </template>

    <v-card>
      <v-card-title class="headline grey lighten-2">
        이벤트 페이지 선택
        <v-spacer></v-spacer>
        <v-btn icon @click="close">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>

      <v-card-text class="pa-4">
        <!-- 검색 영역 -->
        <v-sheet outlined class="pa-3 mb-3">
          <v-row align="center" no-gutters>
            <v-col cols="3">
              <v-select outlined dense hide-details :items="searchTypes" v-model="searchType" class="mr-2"></v-select>
            </v-col>
            <v-col cols="7">
              <v-text-field placeholder="검색어를 입력해주세요" outlined dense hide-details v-model="keyword" @keyup.enter="searchEventPages" class="mr-2"></v-text-field>
            </v-col>
            <v-col cols="2">
              <v-btn color="primary" dark depressed block @click="searchEventPages">
                <v-icon small left>mdi-magnify</v-icon>
                검색
              </v-btn>
            </v-col>
          </v-row>
        </v-sheet>

        <!-- 이벤트 페이지 목록 -->
        <v-data-table
          v-model="selected"
          :headers="headers"
          :items="eventPages"
          :single-select="true"
          item-key="code"
          show-select
          class="elevation-1"
          height="400"
          :footer-props="{
            'items-per-page-options': [10, 20, 50],
            itemsPerPageText: '페이지당 아이템수',
          }"
        >
          <template v-slot:item.name="{ item }">
            <div class="font-weight-bold">{{ item.name }}</div>
          </template>
          <template v-slot:item.code="{ item }">
            <v-chip small color="grey lighten-2">{{ item.code }}</v-chip>
          </template>
          <template v-slot:item.created="{ item }">
            {{ item.created ? formatDate(item.created) : "-" }}
          </template>
        </v-data-table>
      </v-card-text>

      <v-divider></v-divider>

      <v-card-actions class="pa-4">
        <v-spacer></v-spacer>
        <v-btn color="grey" text @click="close"> 취소 </v-btn>
        <v-btn color="primary" depressed @click="confirm" :disabled="!selected.length"> 선택 완료 </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import axios from "@/api/restApi"
import dayjs from "dayjs"

export default {
  name: "EventPageSelector",

  props: {
    value: {
      type: String,
      default: null,
    },
  },

  data: () => ({
    dialog: false,
    selected: [],
    eventPages: [],
    searchType: "이름",
    searchTypes: ["이름", "코드"],
    keyword: "",
    headers: [
      { text: "이름", value: "name", width: 250 },
      { text: "코드", value: "code", width: 200 },
      { text: "생성일", value: "created", width: 150 },
    ],
  }),

  computed: {
    selectedPageDisplay() {
      if (!this.value) return ""
      const page = this.eventPages.find((p) => p.code === this.value)
      return page ? `${page.name} (${page.code})` : this.value
    },
  },

  watch: {
    dialog(val) {
      if (val) {
        // 다이얼로그가 열릴 때 초기 검색 수행
        this.searchEventPages()
        // 현재 선택된 값이 있으면 선택 상태로 설정
        if (this.value) {
          const page = this.eventPages.find((p) => p.code === this.value)
          if (page) {
            this.selected = [page]
          }
        }
      }
    },
    value(val) {
      if (!val) {
        this.selected = []
      }
    },
  },

  methods: {
    async searchEventPages() {
      try {
        const params = {}
        if (this.keyword) {
          params.type = this.searchType
          params.keyword = this.keyword
        }

        const response = await axios.post("/api/event/select/admin", { params })
        this.eventPages = response.data || []

        // 검색 후 현재 선택된 값 유지
        if (this.value && this.selected.length === 0) {
          const page = this.eventPages.find((p) => p.code === this.value)
          if (page) {
            this.selected = [page]
          }
        }
      } catch (error) {
        console.error("이벤트 페이지 조회 오류:", error)
        this.eventPages = []
      }
    },

    formatDate(date) {
      return dayjs(date).format("YYYY-MM-DD")
    },

    confirm() {
      if (this.selected.length > 0) {
        this.$emit("input", this.selected[0].code)
        this.$emit("select", this.selected[0])
      }
      this.close()
    },

    close() {
      this.dialog = false
    },

    clearSelection() {
      this.$emit("input", null)
      this.$emit("clear")
      this.selected = []
    },
  },
}
</script>

<style scoped></style>
